import $ from "jquery";
import initSelect2 from "select2/dist/js/select2.full";

if (typeof $.fn.select2 === "undefined") {
  initSelect2($);
}
